// Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';

// Libraries
import { Observable, concatMap, take, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Models
import { AppCleanup } from '../models';

// Store
import { AuthState } from '../../modules/auth/state/auth.state';

@Injectable()
export class TokenInterceptor extends AppCleanup implements HttpInterceptor {
	@Select(AuthState.currentAuthToken) authToken$: Observable<string>;

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
		return this.authToken$.pipe(take(1), concatMap(authToken => {
			if (authToken) {
				const requestClone = request.clone({
					setHeaders: {
						Authorization: `Bearer ${authToken}`
					}
				});

				return next.handle(requestClone)
			} else {
				return next.handle(request)
			}
		}))
	}
}
